import {verifyUserWithToken} from './userAction';
import {megaDispatch} from './megaDispatch';
/*
	Dispatches all actions to refresh necessary data.
*/
export const switchDispatch = (action, clientPath, data, user_id, user_token, showEditProgress, selectedRepresentativeUserId) =>
{	

	
	return (dispatch) => {
		switch(action){

			case 'megaDispatch':
			
				dispatch(verifyUserWithToken(clientPath + '/api/user/action/verifyWithToken', user_id, user_token, showEditProgress));
				dispatch(megaDispatch(clientPath, user_id, user_token, showEditProgress, selectedRepresentativeUserId));
			return;
			default: 
			return;
		}
	}
}



// WEBPACK FOOTER //
// ./src/redux/actions/switchDispatch.js